<template>
    <div class="my-interview">
        <Icon class="closeBtn" type="ios-close" @click="handleClose"></Icon>
        <div class="my-header">
            <span class="tit">我的面试</span>
        </div>
        <div class="qr-code-container">
            <div class="imgbox" v-show="!loadingflag" :style="{ background: 'url(' + QRcode + ') 50% 50% no-repeat'}">
                <img v-if="siteType != 1"     :src="siteType == 3 ? logoImage :codeImgBase64" alt="">
            </div>
            <Spin v-if="loadingflag" size="large" style=" position: absolute; top: 170px; left: 50%; transform: translateX(-50%);"></Spin>
            <span class="tit">微信扫码查看详情</span>
        </div>
    </div>
</template>

<script>
    import {getQrCodeData} from '@/api/indexPage'
    export default {
        props: {
            siteType:{
                type: String // //1：主站；2：学校；3：渠道
            },
            chanelbadge:{
                type: String
            }
        },
        data() {
            return {
                QRcode: '',
                loadingflag: true,
                codeImgBase64:'',
                logoImage:'',
            }
        },
        created() {
            this.createdQrCode()
            if(this.siteType == 1 ){
                // this.codeImgBase64 = this.img3

            }else if(this.siteType == 3 ){
                this.logoImage = this.chanelbadge

            }else{

                this.codeImgBase64 = JSON.parse(sessionStorage.getItem('schoolIcon'));
            }
            // this.codeImgBase64 = JSON.parse(sessionStorage.getItem('schoolIcon'));
        },
        methods: {
            handleClose() {
                this.$emit('handleClose')
            },
            async createdQrCode() {
                try {
                    const params = {
                        type: '4'
                    }
                    this.loadingflag = true;
                    const data = await getQrCodeData(params)
                    if(data.apiStatus) {
                        this.QRcode = data.QRcode
                    }
                    this.loadingflag = false;
                }catch (e) {
                    this.$Message.error('接口请求失败')
                    this.loadingflag = false;
                }
            },
        },

    }
</script>

<style scoped lang="less">
    .my-interview {
        width: 100%;
        position: relative;
        .closeBtn {
            width: 36px;
            height: 36px;
            color: rgba(255,255,255,0.8);
            position: absolute;
            right: -10px;
            top: -30px;
            font-size: 34px;
            font-weight: bold;
        }
        .closeBtn:hover {
            cursor: pointer;
            color: rgba(255,255,255,1);
        }
        .my-header {
            width: 100%;
            height: 80px;
            background: url("../../assets/collectAndMy/interview-dialog.png") center no-repeat;
            background-size: 100% 100%;
            border-radius: 8px 8px 0 0;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            .tit {
                font-size: 18px;
                font-weight: bold;
                color: #17233D;
                line-height: 24px;
            }
        }
        .qr-code-container, .loading-box {
            height: 440px;
            border-radius: 0 0 8px 8px;
            display: flex;
            text-align: center;
            justify-content: center;
            // position: relative;
            // img {
            //     width: 110px;
            //     height: 110px;
            //     position: absolute;
            //     top: 56px;
            //     left: 50%;
            //     transform: translateX(-50%);
            // }
            .imgbox{
                width: 240px;
                height: 240px;
                margin: 56px 0 24px 0;
                line-height: 240px;
                text-align: center;
                background-size: 100% 100% !important;
                img{
                    width: 110px;
                    height: 110px;
                    border-radius: 50%;
                    vertical-align: middle;
                }
            }
            .tit {
                display: block;
                font-size: 14px;
                color: #515A6E;
                line-height: 19px;
                position: absolute;
                bottom: 104px;
                left: 50%;
                transform: translateX(-50%);
            }
        }

    }



</style>



// WEBPACK FOOTER //
// src/components/dialog/myInterviewDialog.vue